import React from 'react';
import WhyChooseUsImage from '../../assest/page8.png'
import './whychooseus.scss'

const WhyChooseUs = () => {
	const data = [
		{
			id: 1,
			title: "END-TO-END ACCOUNT MANAGEMENT",
			desc: "From onboarding and QBR to renewals, support, and growth, Sciqus AMS covers the complete account lifecycle in one unified platform."
		},
		{
			id: 2,
			title: "COST-EFFICIENT SOLUTION",
			desc: "Purpose-built workflows eliminate the need for multiple tools, manual tracking, and heavy customization, reducing operational and tech costs."
		},
		{
			id: 3,
			title: "CLIENT-CENTRIC APPROACH",
			desc: "Every engagement is driven by client outcomes—retention, value realization, and sustainable growth with measurable long-term business impact."
		}
	];
	
	return (
		<>
			<div id="whyus" className="mainWhyChooseUs">
				<div className="subWhyChooseUs">
					<div className="WhyChooseUs">
						<div className="WhyChooseUsLeftSide">
							<img src={WhyChooseUsImage} alt="Why Choose Us" />
							<h2>Why Choose Us?</h2>
						</div>
						
						<div className="WhyChooseUsRightSide">
							<div className="subWhyChooseUsRightSide">
									{data.map ((item) => (
										<>
											
											<div className="WhyChooseUsRightSideListContent">
												<div className="circle">{item.id}</div>
												<div className="WhyChooseUsRightSideList">
													<h4>{item.title}</h4>
													<p>{item.desc}</p>
												</div>
											</div>
										
										</>
									))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default WhyChooseUs;